<template>
  <div class="licheng">
    <div class="li clearfix animation srcospcur" v-for="item in list" :key="item.id">
      <div class="time">{{item.listTitle}}</div>
      <div class="txt">
        <div class="table">
          <div class="table-cell" v-if="item.title=='2007'">
            <p>宝钢金属有限公司成立</p>
          </div>
          <div v-else class="table-cell" v-html="item.content"></div>
        </div>
      </div>
      <div class="ico">
        <img v-for="(img,index) in item.imgs" :key="index" :src="img" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: [Object, Array]
  },
  data() {
    return {
      list: this.$props.data || []
    };
  },
  created() {
    if (this.$props.data.length > 0) {
      let arr = this.$props.data.map(item => {
        item.imgs = item.imageUrl.split(",");
        return item;
      });
      this.$set(this.$data, "list", arr);
    }
  }
};
</script>